import React from 'react';
import PropTypes from 'prop-types';
import { RowData } from './RowData/RowData';

const Header = ({ customTableSetup, headers }) => {

  const ActionCol = () => {
    const bodyActions = customTableSetup?.body?.actionCol?.actions || [];

    if(customTableSetup?.header?.actionCol && bodyActions.length > 0) {
      const actionCol = customTableSetup.header.actionCol;
      const classes = bodyActions.length === 1 ? 'sm-action-data' : (actionCol.classes || 'action-header');

      return(
        <th className={`${classes}`}></th>
      );
    }

    return null;
  };

  return (
    <thead>
      <tr>
        <RowData headers={headers} />
        <ActionCol />
      </tr>
    </thead>
  );
};

Header.propTypes = {
  headers: PropTypes.array,
  customTableSetup: PropTypes.object.isRequired
};

export {
  Header,
};
